import { Tabs } from './Tabs';

export type { TypeTabsProps } from './types';
export default Tabs;
